import { createGlobalStyle } from 'styled-components';

export default createGlobalStyle`
  *,
  *:before,
  *:after {
    box-sizing: border-box;
  }

  html,
  body {
    height: 100%;
  }

  html {
    font-size: 100%;
    -webkit-text-size-adjust: 100%;
  }

  body {
    margin: 0;
    background-color: ${(props) => props.theme.color.bg.main};
    color: ${(props) => props.theme.color.text.main};
    font-family: ${(props) => props.theme.font.family.regular};
    line-height: ${(props) => props.theme.font.lineHeight};
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }

  a img {
    border: 0;
  }

  b,
  strong {
    font-family: ${(props) => props.theme.font.family.bold};
    font-weight: normal;
  }

  // Focus
  :where(a, button, input, select, textarea) {
    @supports selector(:focus-visible) {
      &:focus-visible {
        outline: 2px solid ${(props) => props.theme.color.focus.main};
      }
    }

    // Safari & IE11
    @supports not selector(:focus-visible) {
      &:focus {
        outline: 2px solid ${(props) => props.theme.color.focus.main};
      }
    }
  }

  .dragged {
    z-index: 80;
  }
`;
